import { SetupProviderFormState } from '@Forms/providers/SetupProviderFormContext';
import { CampaignItemDto } from '@contracts/api/dto/campaign/CampaignDto';
import { UpdateRequest } from '@contracts/api/dto/common/UpdateRequest';
import { ProviderItemDto } from '@contracts/api/dto/providers/ProviderDto';
import { SetupCampaignFormState } from '@Forms/campaign/SetupCampaignFormContext';
export const useSetupCampaignUseCaseMapper = (campaign: CampaignItemDto) => {
  return {
    toFormState: async (campaignId: string): Promise<SetupCampaignFormState | undefined> => {
      return {
        description: campaign?.description || '',
        startDate: campaign?.startDate,
        endDate: campaign?.endDate,
        status: campaign?.status || '',
      };
    },
    toDto: (formState: SetupCampaignFormState): UpdateRequest<SetupCampaignFormState> => {
      // @ts-ignore
      return {
        body: {
          description: formState.description,
          startDate: formState.startDate,
          endDate: formState.endDate,
          status: formState.status,
        },
      };
    },
  };
};
